import * as React from 'react';

function HomeIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={26} height={24} viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.525 0a.375.375 0 01.276.113l13.096 13.426a.358.358 0 01-.012.514.377.377 0 01-.525-.012l-2.166-2.22v11.815c0 .201-.167.364-.372.364h-6.548a.368.368 0 01-.371-.364c0-.2.166-.363.371-.363h6.177V11.105c0-.015 0-.03.002-.043L12.543.9l-9.058 10c.04.058.064.128.064.204v12.168h5.805V15.58c0-.2.167-.363.372-.363h6.548c.205 0 .371.163.371.363 0 .201-.166.364-.37.364h-6.178v7.692c0 .201-.166.364-.371.364H3.178a.368.368 0 01-.372-.364V11.65L.65 14.031a.377.377 0 01-.524.031.358.358 0 01-.031-.513L12.254.122A.375.375 0 0112.525 0z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoHomeIcon = React.memo(HomeIcon);
export default MemoHomeIcon;
